module.exports = __webpack_public_path__ + "img/20_10.f2f203d5.png";